export default __webpack_public_path__ + "static/media/movie-db-flask.2b66a3c4.jpg";